// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar container */
.custom-sidebar {
  position: fixed;
  top: 70px; /* match topbar height */
  left: 0;
  bottom: 0;
  width: 257px;
  background-color: #F2F7FE;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.custom-sidebar.collapsed {
  width: 70px;
}

.custom-sidebar .ps-submenu-content {
  background-color: #F2F7FE !important;
}
/* ProSidebar container adjustments */
.custom-sidebar .ps-sidebar-container {
  height: 100%;
  overflow-y: auto;
  background: #F2F7FE;
}

.custom-sidebar.collapsed .ps-sidebar-container {
  min-width: 70px !important;
}

.custom-sidebar:not(.collapsed) .ps-sidebar-container {
  min-width: 257px;
}

/* Collapse/Expand button */
.collapse-btn {
  background: none;
  border: none;
  padding: 15px 12px 5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 100%;
  border-top: 1px solid #E4E4E4;
}

.collapse-btn.collapsed {
  justify-content: center;
}

.collapse-btn.expanded {
  justify-content: flex-end;
}

/* Menu item styles */
.custom-sidebar .ps-menu-icon {
  margin-right: 2px;
}

.custom-sidebar .ps-menu-button {
  gap: 0 !important;
  padding-left: 4px !important;
  height: 38px !important;
}

/* Submenu item styles - expanded */
.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button {
  padding-left: 15px !important;
  color: #838FB4;
  font-size: 14px;
  margin-top: 0px;
  margin-bottom: 5px;
}

.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button.ps-active,
.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button.active {
  background-color: #e6f2ff !important;
  color: #0066CC !important;
  border-right: 5px solid #0066CC;
  border-radius: 5px;
}

/* Submenu item styles - collapsed */
.custom-sidebar.collapsed .ps-submenu-content .ps-menu-button {
  padding-left: 0 !important;
  color: #838FB4;
  font-size: 14px;
}

/* Remove default expand icon */
.ps-submenu-expand-icon {
  display: none !important;
}

/* Active/open submenu button */
.ps-submenu-open > .ps-menu-button {
  background-color: #e6f2ff !important;
  color: #0066CC !important;
}

 `, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS,EAAE,wBAAwB;EACnC,OAAO;EACP,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;AACA,qCAAqC;AACrC;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":["/* Sidebar container */\n.custom-sidebar {\n  position: fixed;\n  top: 70px; /* match topbar height */\n  left: 0;\n  bottom: 0;\n  width: 257px;\n  background-color: #F2F7FE;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n}\n\n.custom-sidebar.collapsed {\n  width: 70px;\n}\n\n.custom-sidebar .ps-submenu-content {\n  background-color: #F2F7FE !important;\n}\n/* ProSidebar container adjustments */\n.custom-sidebar .ps-sidebar-container {\n  height: 100%;\n  overflow-y: auto;\n  background: #F2F7FE;\n}\n\n.custom-sidebar.collapsed .ps-sidebar-container {\n  min-width: 70px !important;\n}\n\n.custom-sidebar:not(.collapsed) .ps-sidebar-container {\n  min-width: 257px;\n}\n\n/* Collapse/Expand button */\n.collapse-btn {\n  background: none;\n  border: none;\n  padding: 15px 12px 5px 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n  border-top: 1px solid #E4E4E4;\n}\n\n.collapse-btn.collapsed {\n  justify-content: center;\n}\n\n.collapse-btn.expanded {\n  justify-content: flex-end;\n}\n\n/* Menu item styles */\n.custom-sidebar .ps-menu-icon {\n  margin-right: 2px;\n}\n\n.custom-sidebar .ps-menu-button {\n  gap: 0 !important;\n  padding-left: 4px !important;\n  height: 38px !important;\n}\n\n/* Submenu item styles - expanded */\n.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button {\n  padding-left: 15px !important;\n  color: #838FB4;\n  font-size: 14px;\n  margin-top: 0px;\n  margin-bottom: 5px;\n}\n\n.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button.ps-active,\n.custom-sidebar:not(.collapsed) .ps-submenu-content .ps-menu-button.active {\n  background-color: #e6f2ff !important;\n  color: #0066CC !important;\n  border-right: 5px solid #0066CC;\n  border-radius: 5px;\n}\n\n/* Submenu item styles - collapsed */\n.custom-sidebar.collapsed .ps-submenu-content .ps-menu-button {\n  padding-left: 0 !important;\n  color: #838FB4;\n  font-size: 14px;\n}\n\n/* Remove default expand icon */\n.ps-submenu-expand-icon {\n  display: none !important;\n}\n\n/* Active/open submenu button */\n.ps-submenu-open > .ps-menu-button {\n  background-color: #e6f2ff !important;\n  color: #0066CC !important;\n}\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
